import { render } from "./App.vue?vue&type=template&id=4aa38baa&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=4aa38baa&lang=less"

import exportComponent from "/Users/yong/woolive/webtpl/web/events/uinfo/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__